import { c as _c } from "react/compiler-runtime";
import { CLI_CLIENT_LABEL_CONSOLE, CLI_CLIENT_LABEL_DASHBOARD_ONBOARDING } from '../../../../../../../../../domain/cli-client-labels';
import Badge from '../../../../../common/base/Badge';

// The dashboard and the Console create tokens for themselves, stored under these labels.
// A Map, so a device named like an object property (e.g. "__proto__") isn't looked up as one.
const FRIENDLY_DEVICE_NAMES = new Map<string, string>([[CLI_CLIENT_LABEL_DASHBOARD_ONBOARDING, 'Dashboard login command'], [CLI_CLIENT_LABEL_CONSOLE, 'Hookdeck Console']]);
export const getDeviceName = (device_name: string): string => FRIENDLY_DEVICE_NAMES.get(device_name) ?? (device_name || 'Unnamed device');

// A CLI command shown inline in a sentence, as a small grey monospace badge.
export const CliCommand: React.FC<{
  children: string;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Badge mono={true} neutral={true}>{children}</Badge>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};